import React, { Component } from 'react'

import successbtn from '../../style/success_btn.css'
class Secured extends Component {
    render() {
  
        return (
            <div className={successbtn.container}>
                    {this.props.sockStatus && <p style={{marginRight: '10px', color: 'green', fontWeight: 'bold'}}>256 SSL Encryption</p>}
                      <span className={`${successbtn.lock} ${!this.props.sockStatus && successbtn.unlocked}`} ></span>
                    </div>
        )
      }
  
}
export default  Secured;
